import Entity from 'utilities/entity';
import Category from './category';

class Theme extends Entity {
    // projects() {
    //     return this.hasMany(Project);
    // }

    categories() {
        return this.hasMany(Category);
    }
}

export default new Theme();